module.exports = __webpack_public_path__ + "img/receipt.682aa66a.png";